<script setup lang="ts">
import { defineProps } from "vue";
import InstallerProfileThreeBlocks from "./InstallerProfileThreeBlocks.vue";
import InstallerProfileTable from "./InstallerProfileTable.vue";
import { useTranslate } from "@/composables/useTranslate";
import { InstallationTermin } from "@/types";

const { t } = useTranslate();

defineProps<Props>();
type Props = {
  termins?: InstallationTermin[];
  workerName?: string;
  workerRole?: string;
  workerImage?: string;
  currentAppointment?: string;
  completedTermins?: number;
  completedTerminsPercentage?: number;
  bonus?: number;
  isReport: boolean;
};
</script>

<template>
  <div
    class="max-w-[996px] h-[calc(100vh-52px)] p-[31px] mx-auto overflow-y-auto"
  >
    <!-- Profile details -->
    <div class="w-fit mx-auto flex flex-col items-center">
      <img
        v-if="workerImage"
        class="w-[103px] h-[103px] rounded-[36px] object-cover"
        :src="workerImage"
        alt="Installer image"
      />
      <h4
        class="text-primary-text-color text-xl font-semibold tracking-[0.01rem] mt-[6px]"
      >
        {{ workerName }}
      </h4>
      <span class="text-[#898790] text-base font-medium tracking-[0.01rem]">{{
        workerRole
      }}</span>
    </div>
    <!-- Three blocks -->
    <InstallerProfileThreeBlocks
      :bonus="bonus"
      :completed-termins="completedTermins"
      :completed-termins-percentage="completedTerminsPercentage"
      :current-appointment="currentAppointment"
      :termins="termins?.length"
      :is-report="isReport"
    />
    <!-- Appointments -->
    <div>
      <h3
        class="text-primary-text-color mt-[24px] mb-3 text-xl leading-8 font-semibold tracking-[0.01rem]"
      >
        {{ t("installers.appointments_this_month") }}
      </h3>

      <InstallerProfileTable
        v-if="termins && termins.length > 0"
        :termins="termins"
      />

      <div
        v-else
        class="w-full h-[35vh] short:h-[42vh] tall:h-[49vh] flex items-center justify-center"
      >
        <div class="flex flex-col items-center gap-2">
          <img
            src="@/assets/installer-no-appointments.svg"
            alt="No appointments yet"
          />
          <span
            class="text-[#898790] text-base leading-[26px] tracking-[0.01rem] font-medium"
            >{{ t("installers.no_termins_yet") }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
